import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const images = ['https://cdn.magicpatterns.com/uploads/rYA7D3nBvncaByuCJpseEW/Diseno_1.png', 'https://cdn.magicpatterns.com/uploads/2u6YMe4GBKSzQEHoxSxGER/Diseno_3.png', 'https://cdn.magicpatterns.com/uploads/bSi16cjT3kqioGijvXcZdu/Diseno_6.png', 'https://cdn.magicpatterns.com/uploads/tuNw6gXa9d47kuNNMUpsBQ/Diseno_2.png', 'https://cdn.magicpatterns.com/uploads/t4ofbr1yFXTs498afQhXTS/Diseno_sin_titulo-38.png'];
export function TshirtCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);
  const scrollToPurchase = () => {
    const element = document.getElementById('compra');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="relative w-full max-w-md mx-auto aspect-square overflow-hidden rounded-xl shadow-2xl cursor-pointer group" onClick={scrollToPurchase} data-id="element-244">
      <AnimatePresence mode="wait" data-id="element-245">
        <motion.img key={currentIndex} src={images[currentIndex]} alt={`Diseño de remera ${currentIndex + 1}`} initial={{
        opacity: 0,
        x: 100
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: -100
      }} transition={{
        duration: 0.5
      }} className="absolute inset-0 w-full h-full object-cover bg-gray-100" data-id="element-246" />
      </AnimatePresence>

      {/* Overlay gradient for text readability if needed, or just hover effect */}
      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300 flex items-center justify-center" data-id="element-247">
        <span className="opacity-0 group-hover:opacity-100 bg-orange-500 text-white px-4 py-2 rounded-full font-bold transform scale-90 group-hover:scale-100 transition-all duration-300 shadow-lg" data-id="element-248">
          Ver Oferta
        </span>
      </div>

      {/* Dots navigation */}
      <div className="absolute bottom-4 left-0 right-0 flex justify-center space-x-2" data-id="element-249">
        {images.map((_, idx) => <button key={idx} onClick={e => {
        e.stopPropagation();
        setCurrentIndex(idx);
      }} className={`w-3 h-3 rounded-full transition-all duration-300 ${idx === currentIndex ? 'bg-orange-500 w-6' : 'bg-white/70 hover:bg-white'}`} aria-label={`Ver imagen ${idx + 1}`} data-id="element-250" />)}
      </div>
    </div>;
}